// Model/schema for Add New Listing
'use client';

import { z } from 'zod';

import { extendedVehicleInfoSchema, vehicleInfoSchema } from './listing.schema';

export type ExtendedVehicleInfoFormValues = z.infer<typeof extendedVehicleInfoSchema>;

export type VehicleInfoFormValues = z.infer<typeof vehicleInfoSchema>;

export type CarImage = {
  imageId: string;
  imageUrl: string;
  isMain: boolean;
  filePath: string;
};

export type ListingPayload = {
  // Vehicle Info
  packageId: number;
  id?: string;
  vin: string;
  make: string;
  model: string;
  countryCode: string;
  stateCode: string;
  countryName?: string;
  stateName?: string;
  zipCode: number | string;
  city: string;
  year: number | string;
  vehicleEra: string;
  price: number | null;
  orBestOffer: boolean;
  shortVehicleDescription: string;
  listingId?: string;
  title?: string;
  subTitle?: string;
  url?: string;
  videoUrl1?: string;
  videoUrl2?: string;
  videoUrl3?: string;
  mainImageUrl?: string;
  mainImageId?: string;
  titleStatus?: string;
  transmission?: string;
  odometer?: number | string | null;
  engineSize?: string;
  engineType?: string;
  enginePower?: string;
  vehicleRestorationHistory?: string;
  vehicleRestorationHistoryExplained?: string;
  exteriorColor?: string;
  interiorColor?: string;
  exteriorCondition?: string;
  exteriorConditionMoreDescription?: string;
  seatMaterial?: string;
  seatMaterialOther?: string;
  // Comfort Features
  airConditioning?: boolean;
  bucketSeats?: boolean;
  powerBrakes?: boolean;
  powerSteering?: boolean;
  powerWindows?: boolean;
  powerSeats?: boolean;
  tiltWheel?: boolean;
  hasConvertibleTop?: boolean;
  engineCondition?: string;
  engineHistory?: string;
  carImages?: CarImage[];
  titleStatusName?: string;
  transmissionName?: string;
  engineSizeName?: string;
  engineTypeName?: string;
  enginePowerName?: string;
  vehicleRestorationHistoryName?: string;
  status?: string;
  vehicleEraName?: string;
  userId?: string;
  userName?: string;
};

// Generic ref type for forms
export type FormRefType<T> = {
  validate: () => Promise<boolean>;
  getValues: () => T;
  reset: () => void;
  getValuesWithoutValidation: () => T;
};

export type ZipCodeResult = {
  country: string;
  countryabbreviation: string;
  postcode: string;
  places: {
    placename: string;
    city: string;
    longitude: string;
    latitude: string;
    state: string;
    stateabbreviation: string;
  }[];
};

export type UserPackage = {
  packageId: number;
  packageName: string;
  packageOffersId: number;
  totalSlot: number;
  usedSlot: number;
  photosPerListing: number;
  embedVideosPerListing: number;
};
